import React from "react";
import { ReducerState } from "reducers";
import { connect } from "react-redux";

import "./Avatar.css";
import { useTranslation } from "react-i18next";

interface AvatarProps {
  hash: string;
  userID?: string;
}

const AvatarInternal: React.FC<AvatarProps> = ({ hash, userID }) => {
  const [t] = useTranslation();

  return (
    <figure className="image is-32x32" title={t("commun_parametre_utilisateur")}>
      {hash ? (
        <div className="avatar">
          <img
            className="is-rounded"
            src={`https://www.gravatar.com/avatar/${hash}?s=32&d=identicon`}
            alt={userID ?? ""}
            width={32}
            height={32}
          />
          <div className="avatar-user">{userID}</div>
        </div>
      ) : (
        <img className="is-rounded" src="https://bulma.io/images/placeholders/32x32.png" />
      )}
    </figure>
  );
};

function mapStateToProps(state: ReducerState) {
  return {
    hash: state.userSettings.hash,
    userID: state.userSettings.id
  };
}

export const Avatar = connect<AvatarProps>(mapStateToProps)(AvatarInternal);
